<template>
  <div>
    <div>
      <div v-if="componentData.direction == 'Horizontal'">
        <div
          class="instruction_title text-left para-mrgn-20"
          v-translate:dynamic_string="{
            key: `${translationKeyInitial}_formattedBody`,
            val: lang,
            html: question.formattedBody
          }"
          v-html="question.formattedBody"
        />
        <div class="row">
          <div
            class="col-md-3 pr-10 text-right"
            v-translate:dynamic_string="{
              key: `${translationKeyInitial}_minValueLabel`,
              val: lang,
              html: [!!componentData.minValueLabel ? componentData.minValueLabel : '']
            }"
          >
            {{ !!componentData.minValueLabel ? componentData.minValueLabel : "" }}
          </div>
          <div class="col-md-6">
            <ds-slider
              @click.once="$emit('onClick', question)"
              ref="slider"
              :value="getValueForVasScale()"
              direction="horizontal"
              class="horizontal-vue-slider"
              :width="componentData.restrainLengthValue <= 65 ? componentData.restrainLengthValue + 'mm' : 65 + 'mm'"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :disabled="isFieldDisabled"
              :labelActiveStyle="labelActiveStyle"
              :dotSize="pointerValue"
              :tooltip="showTooltip"
              @drag-end="onAnswerChange"
              @click-end="onAnswerChange"
            ></ds-slider>
            <div class="pt-10 scaleLabels-vas">
              <span :style="{ 'margin-left': 15 + 'px' }">{{ componentData.minValue }}</span>
              <span class="pull-right">{{ componentData.maxValue }}</span>
            </div>
          </div>
          <div
            class="col-md-3"
            v-translate:dynamic_string="{
              key: `${translationKeyInitial}_maxValueLabel`,
              val: lang,
              html: [!!componentData.maxValueLabel ? componentData.maxValueLabel : '']
            }"
          >
            {{ !!componentData.maxValueLabel ? componentData.maxValueLabel : "" }}
          </div>
        </div>
      </div>
    </div>
    <div class="option-section pad-top20" v-if="componentData.direction == 'Vertical'">
      <div>
        <div>
          <div>
            <div>
              <div
                v-translate:dynamic_string="{
                  key: `${translationKeyInitial}_formattedBody`,
                  val: lang,
                  html: question.formattedBody
                }"
                v-html="question.formattedBody"
                class="instruction_title text-center para-mrgn-20"
              />
            </div>
            <div>
              <div class="scaleLabels align">
                <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ componentData.maxValue }}</span>
                <span
                  :style="{ 'margin-left': 30 + 'px' }"
                  class="scaleLabels"
                  v-translate:dynamic_string="{
                    key: `${translationKeyInitial}_maxValueLabel`,
                    val: lang,
                    html: [!!componentData.maxValueLabel ? componentData.maxValueLabel : '']
                  }"
                  >{{ !!componentData.maxValueLabel ? componentData.maxValueLabel : "" }}</span
                >
              </div>
              <ds-slider
                ref="slider"
                :value="getValueForVasScale()"
                direction="vertical"
                class="pl-20 moz-style"
                width="2"
                :height="componentData.restrainLengthValue <= 55 ? componentData.restrainLengthValue + 'mm' : 55 + 'mm'"
                :min="componentData.minValue"
                :max="componentData.maxValue"
                :disabled="isFieldDisabled"
                :labelActiveStyle="labelActiveStyle"
                :dotSize="pointerValue"
                :tooltip="showTooltip"
                style="text-align: -webkit-center"
                @drag-end="onAnswerChange"
                @click-end="onAnswerChange"
              ></ds-slider>
              <div class="scaleLabels align">
                <span :style="{ 'margin-left': 30 + 'px' }">{{ componentData.minValue }}</span>
                <span
                  :style="{ 'margin-left': 30 + 'px' }"
                  v-translate:dynamic_string="{
                    key: `${translationKeyInitial}_minValueLabel`,
                    val: lang,
                    html: [!!componentData.minValueLabel ? componentData.minValueLabel : '']
                  }"
                  >{{ !!componentData.minValueLabel ? componentData.minValueLabel : "" }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import dsSlider from "@/lib/ds-slider-component";

export default {
  name: "vas",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {},
      pointerValue: 0,
      showTooltip: false,
      labelActiveStyle: {
        color: ""
      }
    };
  },
  components: {
    dsSlider
  },
  mounted() {
    this.question.answer = this.getValueForVasScale();
    if (this.question.answer) {
      this.pointerValue = 16;
      this.showTooltip = "always";
      this.labelActiveStyle.color = "#3498db";
    }
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  methods: {
    onAnswerChange(e) {
      this.question.skipped = false;
      this.pointerValue = 16;
      this.showTooltip = "always";
      this.labelActiveStyle.color = "#3498db";
      this.question.answer = e.val;
      this.$nextTick(() => {
        this.onChangeOptions(e);
        this.$emit("onAnswerChange", this.question);
      });
    },
    getValueForVasScale() {
      if (this.question.skipped) {
        this.pointerValue = 0;
        this.showTooltip = false;
        this.labelActiveStyle.color = "";
        return;
      }
      if (!this.question.hasOwnProperty("answer") || this.question.answer === false) {
        return undefined;
      }
      if (this.question.answer || this.question.answer === 0) {
        return this.question.answer;
      }
      if (this.componentData.defaultPointerPosition == "max") {
        return this.componentData.maxValue;
      }
      return this.componentData.minValue;
    },
    onChangeOptions(e) {
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
    },
    clearAnswer(){
      this.question.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  },
};
</script>

<style>
.text-right {
  text-align: end;
}
.align {
  text-align: center;
}
.moz-style {
  text-align: -moz-center !important;
}
</style>
